import { gql } from "@apollo/client";

export const FETCH_FINANCIALS = gql`
  query FindCorporateByUuid($uuid: ID!) {
    findCorporateByUuid(uuid: $uuid) {
      costOfSales
      divisionFinancial {
        costOfSales
        grossMargin
        name
        percentage
        revenue
        uuid
        productGroupFinancials {
          costOfSales
          grossMargin
          name
          percentage
          revenue
          uuid
          productFinancials {
            costOfSales
            grossMargin
            name
            percentage
            revenue
            uuid
          }
        }
      }
      grossMargin
      name
      percentage
      revenue
      uuid
    }
  }
`;